(function(window) {
  'use strict';

  var WORKER_URL = 'https://gold-price-proxy.hamedsafwat37.workers.dev';
  var CACHE_DURATION = 24 * 60 * 60 * 1000; // 24 ساعة
  var REQUEST_COOLDOWN = 5000; // 5 ثواني لمنع duplicate requests

  var memoryCache = { gold: null, silver: null };
  var lastRequestTime = { gold: 0, silver: 0 };
  var fallbackPrices = {
    XAU: { 24: 556.38, 22: 510.02, 21: 486.83, 20: 463.65, 18: 417.29, 16: 370.92, 14: 324.55, 10: 231.82 },
    XAG: { 999: 11.06, 925: 10.23, 900: 9.95, 800: 8.85 }
  };
  var activePromises = { gold: null, silver: null };
  var requestCounter = { gold: 0, silver: 0 };

  var GoldPriceManager = {

    getPrices: function(metal) {
      metal = metal || 'XAU';
      var metalType = metal === 'XAG' ? 'silver' : 'gold';
      var now = Date.now();
      var timeSinceLast = now - lastRequestTime[metalType];

      if (timeSinceLast < REQUEST_COOLDOWN && memoryCache[metalType]) {
        return Promise.resolve(memoryCache[metalType]);
      }

      if (memoryCache[metalType]) return Promise.resolve(memoryCache[metalType]);

      if (activePromises[metalType]) return activePromises[metalType];

      lastRequestTime[metalType] = now;
      requestCounter[metalType]++;

      var self = this;
      activePromises[metalType] = fetch(WORKER_URL)
        .then(res => res.json())
        .then(data => {
          var pricesData = metal === 'XAU' ? data.gold.prices : data.silver.prices;
          if (!pricesData) throw new Error('Prices not found for ' + metal);

          memoryCache[metalType] = pricesData;
          self._saveToLocalStorage(metal, pricesData);
          activePromises[metalType] = null;
          return pricesData;
        })
        .catch(err => {
          console.error('❌ Worker fetch error for', metal, err);
          activePromises[metalType] = null;

          // fallback
          memoryCache[metalType] = fallbackPrices[metal];
          return fallbackPrices[metal];
        });

      return activePromises[metalType];
    },

    calculatePrice: function(metal, weightInGrams, grade) {
      var prices;
      if (metal === 'XAU') prices = memoryCache.gold;
      else if (metal === 'XAG') prices = memoryCache.silver;
      else throw new Error('Unknown metal');

      if (!prices || !prices[grade]) throw new Error('Price for this grade not found');

      return weightInGrams * prices[grade];
    },

    _saveToLocalStorage: function(metal, prices) {
      try {
        var key = 'metalPrices_' + metal;
        localStorage.setItem(key, JSON.stringify({
          prices: prices,
          timestamp: new Date().getTime()
        }));
      } catch (e) {
        console.error('localStorage save error:', e);
      }
    },

    clearCache: function() {
      memoryCache = { gold: null, silver: null };
      lastRequestTime = { gold: 0, silver: 0 };
      requestCounter = { gold: 0, silver: 0 };
      try {
        localStorage.removeItem('metalPrices_XAU');
        localStorage.removeItem('metalPrices_XAG');
      } catch(e) {}
    },

    getStats: function() {
      var stats = {
        requests: requestCounter,
        memory: { gold: !!memoryCache.gold, silver: !!memoryCache.silver },
        lastRequest: {}
      };
      ['gold','silver'].forEach(type => {
        var timeSince = Date.now() - lastRequestTime[type];
        stats.lastRequest[type] = lastRequestTime[type] === 0 ? 'never' : Math.floor(timeSince/1000) + 's ago';
      });
      return stats;
    }
  };

  window.GoldPriceManager = GoldPriceManager;

  console.log('🚀 GoldPriceManager v3.0 loaded');

})(window);
